import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useParams } from 'react-router-dom';
import { Form } from '@/components/ui/form';
import SpinnerButton from '@/components/common/SpinnerButton';
import Error from '@/components/common/Error';
import { useCoachSelf } from '@/data/coach';
import { Button } from '@/components/ui/button';
import { usePostAvailability, useAvailabilitySelf } from '@/data/availability';
import { schema } from '../../../_validators';
import FormGeneral from '../common/FormGeneral';

const AddAvailabilityForm = ({ setIsAdding }) => {
  const params = useParams();
  const [apiError, setApiError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const coach = useCoachSelf();
  const availabilities = useAvailabilitySelf(params.date);
  const fullAvailabilities = useAvailabilitySelf();
  const postAvailability = usePostAvailability();
  const form = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      startTime: '',
      endTime: '',
      coachActivityId: '',
      locations: []
    }
  });

  const onSubmit = async (values) => {
    setSubmitting(true);
    try {
      setApiError('');
      const payload = {
        date: params.date,
        coachId: coach.data.id,
        coachActivityId: values.coachActivityId,
        startTime: values.startTime,
        endTime: values.endTime,
        locations: values.locations
      };
      const newAvailability = await postAvailability(payload);
      await availabilities.mutate((curr) => [...curr, newAvailability], false);
      fullAvailabilities.mutate();
      setIsAdding(false);
      setSubmitting(false);
    } catch (err) {
      setApiError(err.message);
      setSubmitting(false);
    }
  };

  return (
    <div>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
          <FormGeneral />
          {apiError && <Error error={apiError} />}
          <div className="flex justify-between py-2">
            <Button variant="outline" onClick={() => setIsAdding(false)}>
              Cancel
            </Button>
            <SpinnerButton loading={submitting}>Save</SpinnerButton>
          </div>
        </form>
      </Form>
    </div>
  );
};

export default AddAvailabilityForm;
